<template>
    <div class="main">
      <div class="timain">4-0-4</div>
      <div class="botitle">#/ 当前页面开发中...</div>
      <div class="back-home">
        <router-link to="/">回到首页</router-link>
      </div>
    </div>
</template>

<script>
    export default {
        name: "err404"
    }
</script>

<style scoped>
.main{background: #00a0ea; width: 100vw; text-align: center; display: flex; justify-content: center; align-items: center;
  height: 100vh;flex-direction:column;}
  .timain{
    font-size: 10vw; color: white;
  }
  .botitle{font-size: 1.5vw; color: rgba(255,255,255,0.5); }
.back-home{font-size: 2vw; color: white; }
.back-home a{ color: white;}
.back-home a:hover{color: rgba(255,255,255,0.5);}
</style>
